import React, { useEffect, useMemo } from 'react'
import { Progress } from 'antd'

import { ReactComponent as CloseIcon } from 'assets/svg/shared/close.svg'
import { useTranslation } from 'react-i18next'
import { WhitelabelConfig } from 'hooks'

let timerId

export const RingtonePlayer = (props) => {
    const { t } = useTranslation()
    const { progressPercent, setRingtonePercent, closePlayer, isPlayerActive, ringtone, deviceId, volume } = props
    const playbackTime = 100

    const audio = useMemo(() => {
        const audio = new Audio(ringtone.src)
        audio.loop = true
        audio.volume = 0.01 * volume
        if (deviceId) {
            audio
                .setSinkId(deviceId)
                .then()
                .catch((error) => console.error(error))
        }
        return audio
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let callback
        const playPromise = audio.play()
        playPromise.then(() => {
            callback = () => audio.pause()
        })
        return () => {
            clearTimeout(timerId)
            callback && callback()
        }
    }, [audio])

    useEffect(() => {
        if (audio) {
            audio.volume = 0.01 * volume
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [volume])

    useEffect(() => {
        if (isPlayerActive) {
            timerId = setTimeout(() => setRingtonePercent(progressPercent - 1), playbackTime)
            progressPercent === 0 && closePlayer()
        } else {
            clearTimeout(timerId)
        }
    }, [closePlayer, isPlayerActive, progressPercent, setRingtonePercent])

    const strokeColor = WhitelabelConfig.colors.primary

    return (
        <>
            <div className="sound-and-devices__player-shadow" onClick={closePlayer}></div>
            <div className="sound-and-devices__player-wrapper">
                <div className="sound-and-devices__player">
                    <div className="sound-and-devices__player__content d-flex justify-content-between flex-fill">
                        <p className="sound-and-devices__player__text">
                            {t('listening')} <b>{ringtone.name}</b> {t('now')}
                        </p>
                        <button type="button" className="sound-and-devices__player__btn" onClick={closePlayer}>
                            <CloseIcon />
                        </button>
                    </div>
                    <div className="sound-and-devices__player__progress">
                        <Progress
                            percent={progressPercent}
                            showInfo={false}
                            strokeColor={strokeColor}
                            trailColor="transparent"
                            strokeWidth={6}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
